import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { ConfigProvider, Empty } from 'ant-design-vue';
import { customerResource } from '@/views/system/customerManage/request';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
import { invoiceRecordList } from '../request';
export default {
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  components: {
    ConfigProvider
  },
  data() {
    return {
      form: {
        customerId: undefined,
        applicationId: undefined,
        insuranceId: undefined,
        invoiceStatus: undefined,
        searchField: undefined,
        searchValue: undefined
      },
      customerList: [],
      applicationList: [],
      productList: [],
      statusList: [{
        key: 'SUCCESS',
        name: '已开票'
      }, {
        key: 'INVOICING',
        name: '开票中'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      noDataText: '暂无数据',
      data: [],
      columns: [{
        slots: {
          title: '发票申请号'
        },
        dataIndex: 'invoiceNo',
        key: 'invoiceNo',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'customerInsuranceName',
        key: 'customerInsuranceName',
        align: 'center'
      }, {
        slots: {
          title: '承保单位'
        },
        dataIndex: 'unitName',
        key: 'unitName',
        align: 'center'
      }, {
        slots: {
          title: '保单来源'
        },
        dataIndex: 'applicationName',
        key: 'applicationName',
        align: 'center'
      }, {
        slots: {
          title: '发票状态'
        },
        dataIndex: 'statusName',
        key: 'statusName',
        align: 'center',
        scopedSlots: {
          customRender: 'statusName'
        }
      }, {
        slots: {
          title: '发票金额'
        },
        dataIndex: 'price',
        key: 'price',
        align: 'center'
      }, {
        slots: {
          title: '发票抬头'
        },
        dataIndex: 'invoiceHead',
        key: 'invoiceHead',
        align: 'center'
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      locale: {
        // 默认图片
        emptyText: () => {
          return `<div class="noDataText">${this.noDataText}</div>`;
        }
      },
      loading: false
    };
  },
  created() {
    // 获取保单归属
    customerResource({}).then(res => {
      this.customerList = res;
      if (res.length == 0) {
        return false;
      }
      let arr = res.filter(item => item.id == Number(sessionStorage.getItem('invoiceRecordCustomerId')));
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('invoiceRecordCustomerId')) : res[0].id;
      sessionStorage.setItem('invoiceRecordCustomerId', this.form.customerId);
      // 获取保单来源
      this.applicationFun();
      // 默认选中条件
      // if (sessionStorage.getItem('invoiceRecordApplicationId')) {
      //   this.form.applicationId = Number(sessionStorage.getItem('invoiceRecordApplicationId'));
      //   this.getInsuranceFun();
      // }
      // if (sessionStorage.getItem('invoiceRecordInsuranceId')) {
      //   this.form.insuranceId = Number(sessionStorage.getItem('invoiceRecordInsuranceId'));
      // }
      // if (
      //   !sessionStorage.getItem('invoiceRecordApplicationId') ||
      //   !sessionStorage.getItem('invoiceRecordInsuranceId')
      // ) {
      //   return false;
      // }
      this.getListData();
    });
  },
  mounted() {},
  destroyed() {
    console.log('-----------销毁------------');
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterOption2(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 保单归属回调
    customerChange(val) {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      this.form.customerId = val;
      this.data = [];
      this.pagination = {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      };
      sessionStorage.setItem('invoiceRecordCustomerId', val);
      this.applicationFun();
    },
    // 获取保单来源
    applicationFun() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    // 保单来源回调
    getInsuranceFun() {
      this.productList = [];
      this.form.insuranceId = undefined;
      if (!this.form.applicationId) {
        return false;
      }
      console.log(this.form.applicationId, '------applicationId------');
      // 获取产品名称
      insuranceResource({
        applicationId: this.form.applicationId,
        customerId: this.form.customerId
      }).then(res => {
        this.productList = res;
      });
      sessionStorage.setItem('invoiceRecordApplicationId', this.form.applicationId);
    },
    // 产品名称回调
    productChange(val) {
      console.log(val, '------insuranceId------');
      sessionStorage.setItem('invoiceRecordInsuranceId', val);
    },
    // 搜索
    searchFun() {
      this.data = [];
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.getListData();
    },
    // 重置
    rest() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      this.form.invoiceStatus = undefined;
      this.form.searchField = undefined;
      this.form.searchValue = undefined;
    },
    async getListData() {
      this.loading = true;
      await invoiceRecordList({
        ...this.form,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
        this.loading = false;
      }).catch(err => {
        this.data = [];
        this.pagination.current = 1;
        this.pagination.total = 0;
        this.loading = false;
      });
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    }
  }
};